import { Component, OnDestroy, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { SuperordenadorComponent } from '../superordenador/superordenador.component'
import { BannerComponent } from '../banner/banner.component'

@Component({
    selector: 'stream-overlay-component',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        SuperordenadorComponent,
        BannerComponent
    ],
    templateUrl: 'stream-overlay.component.html',
    styleUrl: './stream-overlay.component.css'
})
export class StreamOverlayComponent {
  constructor(){}
}